export class ForkliftJobcodesDropDownDto {
    jobId:number;
    jobCode:string;
    constructor(jobId:number,jobCode:string){
        jobId=this.jobId;
        jobCode=this.jobCode;
    }
}